/** plays: content a player can't show (flags in the content picker). English + Arabic (draft). */
const en = {
  "flag": "Won't play",
  "noApps": "it can't show compositions and custom apps",
  "noPdf": "it can't show PDFs",
  "noWidget": "its player app is too old for this app",
  "onOne": "Won't play on {name}: {why}. It keeps playing the rest.",
  "onSome": "Won't play on {n} of {total} players ({names}): {why}. They keep playing the rest."
};
const ar: typeof en = {
  "flag": "لن يُعرض",
  "noApps": "لا يعرض التصاميم والتطبيقات المخصصة",
  "noPdf": "لا يعرض ملفات PDF",
  "noWidget": "تطبيق المشغّل قديم لهذا التطبيق",
  "onOne": "لن يُعرض على {name}: {why}. يستمر في عرض الباقي.",
  "onSome": "لن يُعرض على {n} من {total} مشغلات ({names}): {why}. تستمر في عرض الباقي."
};
export default { en, ar };
